import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Auth gate. Onboarding is no longer mandatory — new users can freely
 * explore the dashboard and tools before completing the Dive Brain, and are
 * nudged via the Welcome / setup checklist on `/dashboard` instead. Setting
 * `requireOnboarded` to `true` on a specific route is still supported (e.g.
 * strategy screens that literally can't function without a Dive Brain).
 */
export default function ProtectedRoute({ children, requireOnboarded = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="text-[#64748B] text-sm tracking-wide">Surfacing…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
}
